var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.load
      ? _c(
          "div",
          { staticClass: "md-layout-item md-size-100" },
          [_c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.load
      ? _c("div", [
          _c(
            "form",
            {
              staticClass: "md-layout",
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validateChain($event)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "md-layout-item md-size-100" },
                [
                  _c("div", { staticClass: "md-title" }, [
                    _vm._v("Integration info")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "md-layout md-gutter" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-85 md-small-size-100"
                      },
                      [
                        _c("field", {
                          ref: "integrationApiKey",
                          attrs: {
                            fieldName: "integrationApiKey",
                            validations: { required: true },
                            fieldValue: _vm.form.integrationApiKey,
                            fieldLabel: "Integration API Key",
                            fieldId: "integrationApiKey",
                            sending: _vm.sending,
                            disable: _vm.canGenerateApiKey === false
                          },
                          on: {
                            setfield: function($event) {
                              return _vm.setFormField($event)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission:isDeveloperOperator",
                            arg: "isDeveloperOperator"
                          }
                        ],
                        staticClass:
                          "md-layout-item md-size-15 md-small-size-100"
                      },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-raised md-primary",
                            on: { click: _vm.generateApiKey }
                          },
                          [_vm._v("New API Key")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "md-layout md-gutter" }, [
                    _c(
                      "div",
                      { staticClass: "md-layout-item md-small-size-100" },
                      [
                        _c("field", {
                          ref: "authDomain",
                          attrs: {
                            fieldName: "authDomain",
                            fieldValue: _vm.form.authDomain,
                            fieldLabel: "Auth domain",
                            fieldId: "authDomain",
                            sending: _vm.sending
                          },
                          on: {
                            setfield: function($event) {
                              return _vm.setFormField($event)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "md-layout-item md-small-size-100" },
                      [
                        _c("field", {
                          ref: "oauthClientApplicationId",
                          attrs: {
                            fieldName: "oauthClientApplicationId",
                            fieldValue: _vm.form.oauthClientApplicationId,
                            fieldLabel: "Oauth Client Application Id",
                            fieldId: "oauth-client-application-id",
                            sending: _vm.sending
                          },
                          on: {
                            setfield: function($event) {
                              return _vm.setFormField($event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "md-layout md-gutter" }, [
                    _c(
                      "div",
                      { staticClass: "md-layout-item md-small-size-100" },
                      [
                        _c("field-select", {
                          ref: "integratorId",
                          attrs: {
                            fieldName: "integratorId",
                            fieldValue: _vm.form.integratorId,
                            fieldLabel: "Integrators",
                            fieldId: "integrator",
                            values: _vm.integrators,
                            valueId: "id",
                            valueLabel: "name",
                            sending: _vm.sending
                          },
                          on: {
                            setfield: function($event) {
                              return _vm.setFormField($event)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "md-layout-item md-small-size-100" },
                      [
                        _c("field", {
                          ref: "oauthClientScopes",
                          attrs: {
                            fieldName: "oauthClientScopes",
                            fieldValue: _vm.form.oauthClientScopes,
                            fieldLabel: "Oauth client scopes",
                            fieldId: "oauth-client-scopes",
                            sending: _vm.sending
                          },
                          on: {
                            setfield: function($event) {
                              return _vm.setFormField($event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "md-layout md-gutter" }, [
                    _c(
                      "div",
                      { staticClass: "md-layout-item md-small-size-100" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            model: {
                              value: _vm.form.enableIntegration,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "enableIntegration", $$v)
                              },
                              expression: "form.enableIntegration"
                            }
                          },
                          [_vm._v("Enable Integration")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.createdOn
                      ? _c(
                          "div",
                          { staticClass: "md-layout-item md-small-size-100" },
                          [
                            _c("label", { attrs: { for: "createdOn" } }, [
                              _vm._v("Created On:")
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(_vm.createdOn))])
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "md-title" }, [
                    _vm._v("Available modules")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout" },
                    _vm._l(_vm.modulesLayer, function(module, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "md-layout-item md-size-15 md-medium-size-35 md-small-size-50"
                        },
                        [
                          _c(
                            "md-checkbox",
                            {
                              attrs: { value: module },
                              model: {
                                value: _vm.tempModules,
                                callback: function($$v) {
                                  _vm.tempModules = $$v
                                },
                                expression: "tempModules"
                              }
                            },
                            [_vm._v(_vm._s(module.name))]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.sending
                    ? _c("md-progress-bar", {
                        attrs: { "md-mode": "indeterminate" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canGenerateApiKey
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission:isDeveloperOperator",
                              arg: "isDeveloperOperator"
                            }
                          ],
                          staticClass: "md-layout md-gutter"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "md-layout-item md-small-size-100" },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-raised md-primary",
                                  attrs: { disabled: _vm.sending },
                                  on: { click: _vm.removeIntegration }
                                },
                                [_vm._v("Remove integration")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout-item md-small-size-100 right-align"
                            },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-raised md-primary",
                                  attrs: {
                                    type: "submit",
                                    disabled: _vm.sending
                                  }
                                },
                                [_vm._v("Save")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3171deb2", { render: render, staticRenderFns: staticRenderFns })
  }
}